import { useContext } from 'react'
import { Statsig } from 'src/sdk/statsig'
import { formatterPrice } from 'src/utils/formatterPrice'
import { generateSectionId } from 'src/utils/generateSectionId'

import { ProductContext } from '../restructure/product/contexts'
import { KITLOOK_WIDGET_EXPERIMENT_ID } from '../common/StatsigExposure/StatsigExposure'
import GoArrowWidget from '../Icons/GoArrowWidget'

export function GoToKitlookWidget() {
  const { kitlooks, product } = useContext(ProductContext)
  const isEnabled = Statsig.useStatsigFeatureGateValue(
    KITLOOK_WIDGET_EXPERIMENT_ID
  )

  if (kitlooks.length === 0 || !isEnabled) return null

  const [firstKitAvailable] = kitlooks
  const KITLOOK_WIDGET_SECTION_ID = generateSectionId(
    'kitlook_section',
    product.productId
  )

  const kitItems = firstKitAvailable.products || []
  const displayImages = kitItems.slice(0, 4)
  const remainingCount = kitItems.length - 4

  const handleScroll = () => {
    const element = document.getElementById(KITLOOK_WIDGET_SECTION_ID)

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleScroll()
    }
  }

  return (
    <div
      onClick={handleScroll}
      tabIndex={0}
      role="button"
      onKeyDown={handleKeyDown}
      className="w-full cursor-pointer flex items-center gap-3 rounded-[10px] border border-neutral04 p-4"
    >
      <div className="grow flex gap-3 items-center">
        <div className="grid grid-cols-2 gap-1 shrink-0">
          {displayImages.map((productItem, index) => {
            const isLastSlot = index === 3
            const showOverlay = isLastSlot && remainingCount > 0
            const item = productItem.items.find(
              (itemKit) =>
                itemKit.isAvailable &&
                itemKit.productId === productItem.productId
            )

            if (!item) return null

            return (
              <div
                key={item.itemId || index}
                className="relative w-[28px] h-[28px] rounded-sm overflow-hidden bg-neutral-100"
              >
                <img
                  src={item.images[0].imageUrl}
                  alt={item.name}
                  className="w-full h-full object-cover"
                />

                {showOverlay && (
                  <div className="absolute inset-0 bg-white/80 flex items-center justify-center">
                    <span className="text-xs text-[#767676] font-medium">
                      +{remainingCount}
                    </span>
                  </div>
                )}
              </div>
            )
          })}
        </div>
        <div className="flex-col gap-1">
          <p className="font-semibold text-sm text-restructure-primary">
            Leve o kit completo por
          </p>
          <div className="flex items-center gap-1">
            <span className="text-restructure-primary font-medium text-xl">
              {formatterPrice(
                firstKitAvailable.sellerDefault.sellerOffer.price
              )}
            </span>
            {firstKitAvailable.sellerDefault.sellerOffer.hasDiscount && (
              <span className="bg-redDiscount py-[2px] px-1 text-sm line-through text-white font-semibold ">
                {formatterPrice(
                  firstKitAvailable.sellerDefault.sellerOffer.listPrice
                )}
              </span>
            )}
          </div>
        </div>
      </div>
      <GoArrowWidget />
    </div>
  )
}
